import React from 'react';
import PropTypes from 'prop-types';
import RadioSelect from 'components/radio_select';

import { sessionStorageGetItem } from 'entrypoints/storage_helpers';
import { storeAnswerToStorage } from '../storage_helpers';
import { trackQuestionAnswered } from '../tracking_helpers';
import Tooltip from './tooltip';
import dictToOptions from '../utils';
import SurveyQuestionShape from '../constants/SurveyQuestionShape';

const SurveyQuestion = props => {
  const { questionKey, question, onAnswerSelected } = props;

  const onChange = ({ selectedOption, form }) => {
    const selectedOptionValue = selectedOption.value;
    storeAnswerToStorage(selectedOption.name, selectedOptionValue);
    form.setFieldValue(selectedOption.name, null);
    trackQuestionAnswered(
      selectedOption.name,
      selectedOptionValue,
      sessionStorageGetItem('surveySource')
    );
    onAnswerSelected();
  };
  return (
    <div className="survey-question">
      <div className="h3 margin-bottom-20px">
        {question.text}
        {question.tooltip && <Tooltip tooltip={question.tooltip} />}
      </div>
      <RadioSelect
        formGroupClassName="padding-top-20px"
        formGroupLabel=""
        name={questionKey}
        onChange={onChange}
        options={dictToOptions(question.answers)}
        radioLabelClassName="survey-answer-btn padding-left-20px width-100 padding-right-20px padding-left-sm-30px padding-right-sm-30px padding-top-15px padding-bottom-15px margin-bottom-15px"
        radioContainerClassName="square-buttons-container d-block"
      />
    </div>
  );
};

SurveyQuestion.propTypes = {
  questionKey: PropTypes.string.isRequired,
  question: SurveyQuestionShape.isRequired,
  onAnswerSelected: PropTypes.func.isRequired,
};

export default SurveyQuestion;
